var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Toolbar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 3V10.3333M14 3C13.5368 3 13.1628 3.42778 12.4172 4.28089L10.3333 6.66667M14 3C14.4644 3 14.836 3.42778 15.5828 4.28089L17.6667 6.66667M3 14H10.3333M3 14C3 14.4632 3.42778 14.8372 4.28089 15.5828L6.66667 17.6667M3 14C3 13.5356 3.42778 13.164 4.28089 12.4172L6.66667 10.3333M25 14H17.6667M25 14C25 13.5368 24.5722 13.1628 23.7191 12.4172L21.3333 10.3333M25 14C25 14.4644 24.5722 14.836 23.7191 15.5828L21.3333 17.6667M14 25V17.0556M14 25C14.4632 25 14.8372 24.5722 15.5828 23.7191L17.6667 21.3333M14 25C13.5356 25 13.164 24.5722 12.4172 23.7191L10.3333 21.3333",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMove);
export default __webpack_public_path__ + "static/media/move.088a95d4a86ccb20c39940fa85830056.svg";
export { ForwardRef as ReactComponent };